// src/pages/admin/AdminDashboard.jsx
import React, { useEffect, useState } from 'react';
import { collectionGroup, getDocs } from 'firebase/firestore';
import { db } from '../../src/pages/app/protected/firebase';
import axios from 'axios';

export default function AdminDashboard() {
  const [activeUsers, setActiveUsers] = useState(0);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);

  useEffect(() => {
    const fetchActiveUsers = async () => {
      const snapshot = await getDocs(collectionGroup(db, 'users'));
      setActiveUsers(snapshot.size);
    };

    const fetchTransactions = async () => {
      const snapshot = await getDocs(collectionGroup(db, 'orders'));
      setTotalTransactions(snapshot.size);
    };

    const fetchRevenue = async () => {
      try {
        const res = await axios.get('https://us-central1-cashmate-v1.cloudfunctions.net/getTotalRevenue');
        setTotalRevenue(res.data.total / 100);
      } catch (err) {
        console.error('Failed to load revenue:', err);
      }
    };

    fetchActiveUsers();
    fetchTransactions();
    fetchRevenue();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Admin Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card label="Active Users" value={activeUsers} />
        <Card label="Total Transactions" value={totalTransactions} />
        <Card label="Total Revenue (MYR)" value={`RM ${totalRevenue.toFixed(2)}`} />
      </div>
    </div>
  );
}

function Card({ label, value }) {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <p className="text-gray-500 text-sm mb-2">{label}</p>
      <h2 className="text-2xl font-bold">{value}</h2>
    </div>
  );
}